import React from 'react';

import { ManHat } from './styles';

export default function Hat() {
  return (
    <ManHat id="hat">
      <path id="Vector_57" d="M453.16 105.34C455.29 112.02 465.52 112.23 470.77 117.15C473.5 119.71 474.77 123.49 477.77 125.77C481.94 128.95 487.96 128.25 493.27 127.49C503.96 125.97 515.44 125.06 525.08 129.67C528.5 131.3 531.57 133.58 535.14 134.91C538.71 136.24 543.14 136.4 546.04 134.04C548.36 132.15 549.21 129.04 551.31 126.96C552.94 125.32 555.21 124.4 557.07 122.96C561.15 119.88 562.91 114.86 564.07 110.06C566.47 100.18 567.16 89.53 563.07 80.16C558.98 70.79 549.14 63.16 538.4 63.65C535.11 63.8 531.9 64.65 528.62 65.01C520.07 65.88 511.62 63.01 503.04 62.52C500.551 62.2171 498.026 62.5616 495.71 63.52C493.963 64.4908 492.457 65.8406 491.3 67.47C487.372 72.6154 484.682 78.5969 483.44 84.95C482.44 89.74 482.39 94.08 476.52 94.82C469.85 95.7 448.65 91.21 453.16 105.34Z" fill="#444444"/>
    </ManHat>
  );
}
